import { Pipe, PipeTransform } from '@angular/core';

type SortableDateRecord = Record<
  string,
  Date | string | number | null | undefined
>;

@Pipe({
  name: 'orderByDate',
  pure: true,
  standalone: false,
})
export class DateOrderPipe implements PipeTransform {
  transform(
    value: SortableDateRecord[],
    sortBy: string
  ): SortableDateRecord[] | undefined {
    if (value) {
      return value.sort((a, b) => {
        if (!a[sortBy]) {
          throw new Error(`Incorrect orderByDate property`);
        }

        const dateA = new Date(a[sortBy]).getTime();
        const dateB = new Date(b[sortBy]).getTime();
        return dateB - dateA;
      });
    }
  }
}
